import { render, staticRenderFns } from "./ChangguanZhanhuiListBlock.vue?vue&type=template&id=4cd0772d&scoped=true"
import script from "./ChangguanZhanhuiListBlock.vue?vue&type=script&lang=js"
export * from "./ChangguanZhanhuiListBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd0772d",
  null
  
)

export default component.exports